export function GoogleAnalyticsScript({ analyticsId }) {
  // useEffect(() => {
  //   if (!analyticsId) return;

  //   const loadAnalytics = () => {
  //     // 1. Load the GA4 gtag.js script
  //     const script = document.createElement('script');
  //     script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
  //     script.async = true;
  //     document.head.appendChild(script);

  //     // 2. Inject the gtag config script
  //     const inlineScript = document.createElement('script');
  //     inlineScript.innerHTML = `
  //       window.dataLayer = window.dataLayer || [];
  //       function gtag(){dataLayer.push(arguments);}
  //       gtag('js', new Date());
  //       gtag('config', '${analyticsId}');
  //     `;
  //     document.head.appendChild(inlineScript);
  //   };

  //   if (document.readyState === 'loading') {
  //     document.addEventListener('DOMContentLoaded', loadAnalytics);
  //   } else {
  //     loadAnalytics();
  //   }

  //   return () => {
  //     document.removeEventListener('DOMContentLoaded', loadAnalytics);
  //   };
  // }, [analyticsId]);

  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${analyticsId}`}
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${analyticsId}');
                  `,
        }}
      />
    </>
  );
}
